export default __webpack_public_path__ + "static/media/upload_file.90caf1ea.svg";